import { render, staticRenderFns } from "./query-result.vue?vue&type=template&id=5a1fcb4d&scoped=true&"
import script from "./query-result.vue?vue&type=script&lang=js&"
export * from "./query-result.vue?vue&type=script&lang=js&"
import style0 from "./query-result.vue?vue&type=style&index=0&id=5a1fcb4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1fcb4d",
  null
  
)

export default component.exports